import { TranslationGroup } from '../i18n/tanslation-group';
import { zh, en } from './i18n';
import { mmIconConstants } from './mm-icon-constants';

export const mmIconTranslationGroup = {
    groupName: mmIconConstants.translationGroup,
    translations: {
        "zh": zh,
        "en": en
    }
} as TranslationGroup